import React from "react";
import OffersTable from "../../UI/Offer/OffersTable";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";

const Offers = () => {
  return (
    <div>
      <PanelHead title="Offers" />
      <PanelBody content={<OffersTable />} />
    </div>
  );
};

export default React.memo(Offers);
